import { useDispatch, useSelector } from "react-redux";
import "./Co2Slider.css";
import React from "react";
import { setSelectedYear } from "../../store/pointsSlice";
import { sumCo2ForYear } from "../../utils/co2";

const FancySlider = ({ value, onChange }) => {
    const marks = [2030, 2050, 2100];

    return (
        <div className="slider-container">
            <input
                type="range"
                min={0}
                max={2}
                step={1}
                value={marks.indexOf(Number(value))}
                onChange={(e) => {
                    onChange(marks[Number(e.target.value)]);
                }}
                className="styled-slider"
            />
            <div className="slider-labels">
                {marks.map((mark, index) => (
                    <span
                        key={mark}
                        className="slider-label"
                        style={{ left: `${(index / 2) * 100}%` }}
                    >
                        {mark}
                    </span>
                ))}
            </div>
        </div>
    );
};

const Co2Slider = () => {
    const dispatch = useDispatch();
    const selectedRegion = useSelector((state) => state.points.selectedRegion);
    const filters = useSelector((state) => state.points.filters);
    const reduxYear = useSelector((state) => state.points.selectedYear);
    const points = useSelector((state) => state.points.points);
    const showGradient = useSelector(
        (state) => state.points.showGradientColoring
    );

    const handleYearChange = (newYear) => {
        dispatch(setSelectedYear(newYear.toString()));
    };

    const activeRegion =
        filters.region !== "all" ? filters.region : selectedRegion;

    const co2 = sumCo2ForYear(
        points.filter((point) => point.region === activeRegion),
        reduxYear
    );

    const totalCo2 = sumCo2ForYear(points, reduxYear);

    let headerText;
    if (activeRegion) {
        headerText = `Потенциал поглощения CO₂ ${co2.toFixed(2)} тыс т`;
    } else if (showGradient) {
        headerText = `Потенциал поглощения CO₂ ${totalCo2.toFixed(2)} тыс т`;
    } else {
        headerText = "Выберите регион для отображения данных";
    }

    return (
        <div className="container-co2">
            <div className="header">
                <h3>{headerText}</h3>
            </div>
            <FancySlider value={reduxYear} onChange={handleYearChange} />
        </div>
    );
};

export default Co2Slider;
